import fingers from "@amo/core/assets/images/icons/fingers.png";

const AvenantDejaPasse = ({ urlPdfContrat }) => {
    return (
        <div id={'etape-avenant-deja-passe'}>
            <div className={'row justify-content-center align-items-center mt-5'}>
                <div className={'col-lg-3 offset-lg-1 col-md-6 col-sm-16 col-12 my-2 text-center'}>
                    <img src={fingers} alt={'Avenant déjà traité'} loading="lazy"/>
                </div>
                <div className={'col-lg-5 col-md-6 col-sm-16 col-12 my-2 text-start text-dark'}>
                    <h2 className={'my-4'}>
                        Cet avenant a <strong className={'text-ternary'}>a été validé</strong>.
                    </h2>
                    <p className={'f-14'}>
                        La modification demandée sur le contrat a bien été prise en compte.
                        Il n'est plus nécessaire de valider la proposition reçue par email.
                    </p>
                    {urlPdfContrat && (
                        <a href={urlPdfContrat} target={'_blank'} className={`btn btn-secondary btn-smaller btn-arrow me-2 mt-4`} rel="noreferrer">
                            Télécharger mon contrat
                        </a>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AvenantDejaPasse;
